




















import { useTaskStore } from '@/store/task';
import { TaskItem as TaskItemType, TaskStatus } from '@/types/task';
import { computed, defineComponent, onMounted, PropType, ref, watchEffect, nextTick } from '@vue/composition-api';
import TaskItem from './task-item/index.vue';
import TaskInfoDialog from './task-dialog/task-info-dialog.vue';
import { useCouponTaskDialog } from '@/hooks/use-coupon-task-dialog';

export default defineComponent({
  name: 'TaskList',
  props: {
    /** 任务nameId列表 */
    taskNameIdList: {
      type: Array as PropType<string []>,
      required: true,
    },
    /** 列表排序函数 */
    sortFunc: {
      type: Function as PropType<(a: TaskItemType, b: TaskItemType) => number>,
      required: false,
    },
  },
  components: {
    TaskItem,
    TaskInfoDialog,
  },
  setup(props) {
    const { getTaskInfo } = useTaskStore();

    /** 任务详情弹窗展示内容 */
    const currentTaskInfo = ref();
    /** 任务信息弹窗 */
    const taskInfoDialog = ref<InstanceType<typeof TaskInfoDialog> | null>(null);
    /** 打开详情弹窗 */
    const onClickTaskInfo = (taskId: string) => {
      if (!taskId) return;
      const taskDetailInfo = getTaskInfo(taskId);
      if (!taskDetailInfo) return;
      currentTaskInfo.value = taskDetailInfo;
      nextTick(() => {
        taskInfoDialog.value?.showTaskInfo();
      });
    };
    /** 是否展示全局详情弹窗 - 任务 */
    const { isShowTaskDetail } = useCouponTaskDialog();
    /** 任务信息列表 */
    const taskInfoList = computed(() => props.taskNameIdList.map(taskId => getTaskInfo(taskId)));
    const showTaskInfoList = computed(() => {
      if (props.sortFunc) return taskInfoList.value.sort(props.sortFunc);
      return taskInfoList.value;
    });
    onMounted(async () => {
      watchEffect(() => {
        isShowTaskDetail((taskId: string) => onClickTaskInfo(taskId));
      });
    });
    const isNeedMargin = computed((): boolean => {
      const taskInfo = showTaskInfoList.value[0];
      //  摘要 & 出现badage提示时，需要加margin-top: 24px
      return taskInfo?.type === 'limit' || taskInfo?.status === TaskStatus.soldOut;
    });
    return {
      isNeedMargin,
      showTaskInfoList,
      /** 详情弹窗展示内容 */
      currentTaskInfo,
      /** 详情弹窗 */
      taskInfoDialog,
      /** 拉起详情弹窗 */
      onClickTaskInfo,
    };
  },
});
